import { Close } from "@mui/icons-material";
import { Dialog, DialogTitle, IconButton, type SxProps } from "@mui/material";

interface ModalProps {
  title: string;
  content: React.JSX.Element;
  open: boolean;
  onClose: () => void;
  sx?: SxProps;
  disableBackdropClick?: boolean;
  /** Muestra la X de cerrar en la esquina superior derecha. */
  showCloseButton?: boolean;
}

export default function Modal({
  title,
  content,
  open,
  onClose,
  sx,
  disableBackdropClick,
  showCloseButton,
}: ModalProps) {
  return (
    <Dialog
      open={open}
      onClose={disableBackdropClick ? undefined : onClose}
      sx={sx ?? {
        width: {
          xs: "100%",
          sm: "100%",
          md: "75%",
        },
        margin: "0 auto",
        ".MuiPaper-root": { width: "100%", maxWidth: "100%" },
      }}
    >
      <DialogTitle sx={showCloseButton ? { pr: 7 } : undefined}>
        {title}
      </DialogTitle>
      {showCloseButton && (
        <IconButton
          aria-label="Cerrar"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      )}
      {content}
    </Dialog>
  );
}
